import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { isFontVariantLoaded, isFontVariantLoadedTracked, trackFontVariantLoaded } from '@@/bits/font_loading'
import { computed, onMounted, ref } from 'vue'

type NumberOfPaths = number
type IconSize = 'small' | 'normal' | 'large'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzIcon',
  props: {
    dir: { default: 'auto' },
    name: null,
    size: { default: 'normal' },
    ariaHidden: { type: Boolean, default: true },
    font: { default: 'oricon' }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { dir: 'ltr' | 'rtl' | 'auto', name: string, size: number | IconSize, ariaHidden: boolean, font: 'immaterial' | 'oricon' | 'wbicons' }

const COLORED_ICONS: Record<string, NumberOfPaths> = {
  'amazon-color': 2,
  'paypal-color': 3,
  'discover-color': 3,
  'jcb-color': 5,
  'mastercard-color': 3,
  'unionpay-color': 5,
  'amex-color': 2,
  'dinersclub-color': 3,
  'visa-color': 3,
  google: 4,
  windows: 4,
  classlink: 4,
  skoletube: 2,
  twitter: 1,
  google_drive_color: 6,
  clever_blue: 1,
  clever_white: 1,
}
// @see https://material.io/design/usability/bidirectionality.html#mirroring-elements
const ORICONS_MIRRORING = [
  // Arrows
  'back',
  'arrow_right',
  'highlight_text',
  'arrow_left',
  'arrow_right',
  'chevron_left_center',
  'chevron_left_left',
  'chevron_right_center',
  'chevron_right_right',
  // Text-related
  'attachment_caption',
  'subscript',
  'superscript',
  'bulleted_list',
  'numbered_list',
  'clipboard',
  'comment',
  'quote',
  'enlarge',
  'dock',
  'expand',
  'padlets',
  'send_back',
  'send_front',
  // Section-related
  'section_arrow_left',
  'section_arrow_right',
  // Movement
  'transfer',
  'external_link',
  'external_link_outline',
  // Passage of time
  'undo',
  'redo',
  // Others
  'note_filled',
  'note_outline',
]

/**
 * For list of icons:
 *
 *  - Go to https://icomoon.io/app/#/projects
 *  - Load appropriate project (*Immaterial* or *Oricons*)
 *  - Click *Generate Font* at the bottom
 *
 */





const isFontLoaded = ref(false)

const isColoredIcon = computed((): boolean => Object.keys(COLORED_ICONS).includes(props.name))

const isMirroringEnabled = computed((): boolean => {
  if (!props.name) return false
  if (props.font !== 'oricon') return false
  return ORICONS_MIRRORING.includes(props.name)
})

// @see https://material.io/design/usability/bidirectionality.html#mirroring-elements
//
// Use `inline-block` to force the element to be transformable:
// https://stackoverflow.com/questions/14883250/css-transform-doesnt-work-on-inline-elements
const rtlTransformClasses = computed((): string => {
  if (!isMirroringEnabled.value) return ''
  if (props.dir === 'rtl') return 'inline-block transform -scale-x-100'
  if (props.dir === 'auto') return 'inline-block rtl:transform rtl:-scale-x-100'
  return ''
})

const numOfPaths = computed((): number => COLORED_ICONS[props.name])

const iconClass = computed((): string => {
  if (props.font === 'immaterial') {
    return 'immaterial-icons'
  } else if (props.font === 'wbicons') {
    return 'wbicons'
  }
  return 'oricon'
})

const styles = computed((): string => {
  let sizeNumber = 24
  if (typeof props.size === 'number') {
    sizeNumber = props.size
  } else if (props.size === 'small') {
    sizeNumber = 18
  } else if (props.size === 'large') {
    sizeNumber = 32
  }
  if (!isFontLoaded.value) {
    return `visibility: hidden; font-size: ${sizeNumber}px; min-width:${sizeNumber}px; max-width:${sizeNumber}px; width: ${sizeNumber}px; height: ${sizeNumber}px;`
  }

  return `font-size: ${sizeNumber}px; max-width:${sizeNumber}px; width: ${sizeNumber}px; height: ${sizeNumber}px; overflow: visible;`
})

onMounted(() => {
  const fontName = props.font == 'immaterial' ? 'immaterial' : 'oricons'
  const fontVariant = `24px ${fontName}`
  if (isFontVariantLoadedTracked(fontVariant)) {
    isFontLoaded.value = isFontVariantLoaded(fontVariant)
  } else {
    trackFontVariantLoaded(`24px ${fontName}`).then((isTrackedFontLoaded) => {
      isFontLoaded.value = isTrackedFontLoaded
    })
  }
})

return { __sfc: true,COLORED_ICONS, ORICONS_MIRRORING, props, isFontLoaded, isColoredIcon, isMirroringEnabled, rtlTransformClasses, numOfPaths, iconClass, styles }
}

})